import React from 'react';

export type ConditionalWrapperProps = {
  /** a text to be rendered in the component.  */
  children: React.ReactNode,
  /** what to test true/false for */
  condition: boolean | undefined,
  /** what to wrap the children with based on the condition */
  wrapper: any,
};

export function ConditionalWrapper({ condition, wrapper, children }: ConditionalWrapperProps) {
  return condition ? wrapper(children) : children;
}
